module.exports = __webpack_public_path__ + "images/stickers/pete-space@2x.8c2b3c553420a6394b9d.png";